import Screen from '../../../../shared/utils/screen';

function TickIcon({ size = 32 }) {
  const style = {
    filter: `drop-shadow(
      ${5 * Screen.widthRatio}px ${5 * Screen.widthRatio}px
      ${5 * Screen.widthRatio}px #000000
    )`,
  };
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size * Screen.widthRatio}
      height={size * Screen.widthRatio}
      style={style}
      viewBox='0 0 48.766 48.766'
    >
      <path
        fill='#19e680'
        d='M48.765 24.382A24.383 24.383 0 1124.382 0a24.383 24.383 0 0124.383 24.382zm-27.2 12.911l18.088-18.091a1.573 1.573 0 000-2.225l-2.225-2.225a1.573 1.573 0 00-2.225 0L20.45 29.507l-6.888-6.888a1.573 1.573 0 00-2.225 0l-2.225 2.224a1.573 1.573 0 000 2.225l10.225 10.225a1.573 1.573 0 002.225 0z'
        data-name='Icon awesome-check-circle'
      ></path>
    </svg>
  );
}

export default TickIcon;
